import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type CementPackagingItemData = {};

export const initialCementPackagingPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
